import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { axiosBaseQuery } from './baseQuery'
import { Patient } from '../types'

export const patientsBFFApi = createApi({
  reducerPath: 'patientsBFFApi',
  tagTypes: ['Patients_BFF'],
  baseQuery: axiosBaseQuery({
    baseUrl: '/bff/patients',
  }),
  endpoints: (build) => ({
    getPatientByExternalId: build.query<
      Patient,
      { externalPatientFetchId: string; providerId?: string; metadata?: Record<string, unknown> }
    >({
      query: ({ externalPatientFetchId, providerId, metadata }) => {
        if (!externalPatientFetchId) {
          throw new Error('externalPatientFetchId is invalid')
        }
        const queryParams = new URLSearchParams()
        if (providerId) {
          queryParams.append('provider-id', providerId)
        }
        if (metadata) {
          queryParams.append('metadata', JSON.stringify(metadata))
        }
        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''
        return {
          url: `/external/${externalPatientFetchId}${queryString}`,
          method: 'get',
        }
      },
    }),
  }),
})

export const { useGetPatientByExternalIdQuery, useLazyGetPatientByExternalIdQuery } = patientsBFFApi
